import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyBRL',
  standalone: true,
})
export class CurrencyBRLPipe implements PipeTransform {
  transform(value: number, includeSymbol: boolean = true): string {
    if(value === null || value === undefined){
      return ''; 
    }
    
    if(includeSymbol){
       return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL', 
      });
    }else {
      return value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
  }
}
